import DownloadableFileOrAlert from './DownloadableFileOrAlert';

export default DownloadableFileOrAlert;